import { type Element } from '@@plate/serialization/unity/groups';

export const createElement = <
    Type extends Element['type'],
    Data extends Omit<Extract<Element, { type: Type }>, 'type' | 'id'> & { id?: string },
>(
    type: Type,
    data: Data,
) => ({
    type,
    id: crypto.randomUUID(),
    ...data,
});
